const benchmarkSettingFrom = (benchmarkSetting) => ({
  companyId: benchmarkSetting.companyId,
  companyName: benchmarkSetting.companyName,
  benchmarkAttributes: {
    [benchmarkSetting.benchmarkAttributeId]: {
      benchmarkAttributeId: benchmarkSetting.benchmarkAttributeId,
      associatedAttribute: {
        id: benchmarkSetting.associatedAttribute.id,
        names: benchmarkSetting.associatedAttribute.names,
      },
      defaultValue: benchmarkSetting.defaultValue,
      ungroupedValue: benchmarkSetting.ungroupedValue,
    },
  },
});

const benchmarkSettingListFrom = (benchmarkSettingList = []) => {
  return benchmarkSettingList.map((benchmarkSetting) => benchmarkSettingFrom(benchmarkSetting));
};

const benchmarkQuestionFrom = (benchmarkQuestion) => ({
  questionId: benchmarkQuestion.questionId,
  questionText: benchmarkQuestion.questionText,
  taggedQuestionCount: benchmarkQuestion.taggedQuestionCount,
  associatedQuestions: {},
  surveyCount: benchmarkQuestion.surveyCount,
  surveyYears: benchmarkQuestion.surveyYears,
});

const benchmarkQuestionListFrom = (benchmarkQuestionList = []) => {
  return benchmarkQuestionList.map((benchmarkQuestion) => benchmarkQuestionFrom(benchmarkQuestion));
};

export { benchmarkSettingFrom, benchmarkSettingListFrom, benchmarkQuestionFrom, benchmarkQuestionListFrom };
